<template>
  <div class="card myTopMargin">
    <!-- Header se zobrazí, pokud je definován nadpis, nebo je sekce volitelná či rozbalovací -->
    <div v-if="title || isOptional || isCollapsible" class="card-header">
      <div class="row align-items-center my-2">
        <!-- Přepínač pro volitelné sekce (isOptional) -->
        <div v-if="isOptional" class="col-auto">
          <div class="form-switch">
            <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                :id="'switch-' + title.replace(/\s+/g, '-')"
                :checked="isVisible"
                @change="$emit('toggle')"
            >
          </div>
        </div>

        <!-- Nadpis sekce -->
        <div class="col-auto">
          <h3>{{ title }}</h3>
        </div>

        <!-- Tlačítko pro rozbalení/sbalení (isCollapsible) -->
        <div v-if="isCollapsible" class="col text-end">
          <button
              class="btn btn-outline-secondary btn-sm"
              type="button"
              @click="isOpen = !isOpen"
              :aria-expanded="isOpen"
          >
            <i :class="isOpen ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </button>
        </div>

        <!-- Ostatní akce přes slot (pokud není zapnuté sbalování) -->
        <div v-else-if="$slots.actions" class="col text-end">
          <slot name="actions"/>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!--
        Obsah se zobrazí pouze pokud:
        1. Sekce je viditelná (isVisible - pro volitelné sekce)
        2. Sekce je rozbalená (isOpen - pro rozbalovací sekce)
      -->
      <div v-show="isVisible && (!isCollapsible || isOpen)">
        <slot/>
      </div>

      <!-- Informace o neaktivní sekci -->
      <div v-if="isOptional && !isVisible" class="text-muted py-2 text-center">
        <small>Sekce <strong>{{ title }}</strong> není aktivní.</small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  // Určuje, zda má sekce vlevo switch pro zapnutí/vypnutí
  isOptional: {
    type: Boolean,
    default: false
  },
  // Řídí viditelnost obsahu u volitelných sekcí (obvykle v-model z rodiče)
  isVisible: {
    type: Boolean,
    default: true
  },
  // Určuje, zda má být sekce rozbalovací (tlačítko vpravo)
  isCollapsible: {
    type: Boolean,
    default: false
  },
  // Výchozí stav rozbalení pro isCollapsible
  defaultOpen: {
    type: Boolean,
    default: true
  }
});

defineEmits(['toggle']);

// Interní stav pro rozbalování
const isOpen = ref(props.defaultOpen);
</script>

<style scoped>
.myTopMargin {
  margin-top: 1.5rem;
}
.form-check-input {
  cursor: pointer;
}
/* Zarovnání ikonek a textu v hlavičce */
.card-header h3 {
  margin-bottom: 0;
}
</style>